webpackJsonp([117880877975936],{

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Invite your teammates'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This is managed via the SnapTest website dashboard (for now). Click on the "Manage collaborators", or just point your browser to https://www.snaptest.io and click "dashboard" in the top-right. You will be able to see all your various accounts:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528948261/teams/manage-collab.png', style: { "max-width": "400px" } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528947768/teams/collab-inv.png', style: { "max-width": "300px" } })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Click to manage your team account, including inviting collaborators and setting a logo:\u200B'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1528948457/teams/org-collab-settings.png', style: { "max-width": "600px" } })
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-invite-js-491c56a8230bf65b3124.js